// extracted by mini-css-extract-plugin
export default {"root":"SectionGallery_root__AQ+Rx"};